export const whoQuestions = [
  {
    questionNumber: "1",
    questionText: "Who is in charge of organizing the annual company retreat?",
    choices: {
      A: "The event will be held next month",
      B: "Our HR department handles that",
      C: "I'll check the schedule and let you know",
    },
    incorrectAnswers: ["A", "C"],
    subCategory: "who",
    audioUrl: `${process.env.PUBLIC_URL}/audios/part2/who/us/who1.mp3`,
    translation: {
      question: "누가 연례 회사 워크샵을 담당합니까?",
      choices: {
        A: "행사는 다음 달에 열립니다",
        B: "우리 인사부서가 담당합니다",
        C: "일정을 확인하고 알려드리겠습니다",
      },
    },
    explanation:
      "(A)는 행사 일정만 언급하며, '누가 담당하는지'에 대한 정보가 없음. (C)는 미래에 확인하겠다는 말로, 질문에 대한 직접적인 답이 아님.",
  },
  {
    questionNumber: "2",
    questionText: "Who designed the company's new logo?",
    choices: {
      A: "The marketing team created it",
      B: "It looks more modern than before",
      C: "We are planning to redesign it next year",
    },
    incorrectAnswers: ["B", "C"],
    subCategory: "who",
    audioUrl: `${process.env.PUBLIC_URL}/audios/part2/who/us/who2.mp3`,
    translation: {
      question: "누가 회사의 새로운 로고를 디자인했습니까?",
      choices: {
        A: "마케팅팀이 만들었습니다",
        B: "이전보다 더 현대적으로 보입니다",
        C: "내년에 다시 디자인할 계획입니다",
      },
    },
    explanation:
      "(B)는 로고에 대한 의견일 뿐, 디자인한 사람이 누구인지에 대한 답이 아님. (C)는 미래 계획을 언급하고 있어 현재의 질문과 맞지 않음.",
  },
// ... existing code ...
{
  questionNumber: "3",
  questionText: "Who is in charge of approving the expense reports?",
  choices: {
    A: "The reports are due by Friday",
    B: "You should check with the finance department",
    C: "I submitted my report yesterday",
  },
  incorrectAnswers: ["A", "C"],
  subCategory: "who",
  audioUrl: `${process.env.PUBLIC_URL}/audios/part2/who/us/who3.mp3`,
  translation: {
    question: "누가 경비 보고서 승인을 담당합니까?",
    choices: {
      A: "보고서 제출 기한은 금요일입니다",
      B: "재무부에 문의해보세요",
      C: "저는 어제 보고서를 제출했습니다",
    },
  },
  explanation:
    "(A)는 보고서 제출 기한에 대한 정보일 뿐, 승인 담당자에 대한 답이 아님. (C)는 개인의 보고서 제출 경험을 말할 뿐, 승인 담당자와 관련이 없음.",
},
// ... existing code ...
{
  questionNumber: "4",
  questionText: "Who will be leading the training session next week?",
  choices: {
    A: "The session will last about two hours",
    B: "I attended the same session last month",
    C: "That hasn't been decided yet",
  },
  incorrectAnswers: ["A", "B"],
  subCategory: "who",
  audioUrl: `${process.env.PUBLIC_URL}/audios/part2/who/us/who4.mp3`,
  translation: {
    question: "다음 주 교육 세션은 누가 진행합니까?",
    choices: {
      A: "세션은 약 2시간 동안 진행됩니다",
      B: "저는 지난달에 같은 세션에 참석했습니다",
      C: "아직 결정되지 않았습니다",
    },
  },
  explanation:
    "(A)는 교육 세션의 길이에 대한 정보만 제공할 뿐, '누가 진행하는지'를 말해주지 않음. (B)는 개인의 과거 참석 경험을 말할 뿐, 이번 교육 진행자와 관련이 없음.",
},
// ... existing code ...
  {
    questionNumber: "5",
    questionText: "Who is responsible for managing our social media accounts?",
    choices: {
      A: "Our marketing team handles that",
      B: "It's important to stay active online",
      C: "I will post an update later today",
    },
    incorrectAnswers: ["B", "C"],
    subCategory: "who",
    audioUrl: `${process.env.PUBLIC_URL}/audios/part2/who/us/who5.mp3`,
    translation: {
      question: "누가 우리 소셜 미디어 계정을 관리합니까?",
      choices: {
        A: "우리 마케팅팀이 담당합니다",
        B: "온라인에서 활동적으로 있는 것이 중요합니다",
        C: "오늘 나중에 업데이트를 게시하겠습니다",
      },
    },
    explanation:
      "(B)는 소셜 미디어 활동이 중요하다는 일반적인 의견이므로 정답이 아님. (C)는 미래의 계획을 언급하며, 현재 담당자를 묻는 질문과 맞지 않음.",
  },
  {
    questionNumber: "6",
    questionText: "Who gave the final approval for the budget?",
    choices: {
      A: "The finance director signed off on it",
      B: "We are reviewing the budget now",
      C: "The report was very detailed",
    },
    incorrectAnswers: ["B", "C"],
    subCategory: "who",
    audioUrl: `${process.env.PUBLIC_URL}/audios/part2/who/us/who6.mp3`,
    translation: {
      question: "누가 예산에 대한 최종 승인을 했습니까?",
      choices: {
        A: "재무 이사가 승인했습니다",
        B: "현재 예산을 검토 중입니다",
        C: "보고서가 매우 상세했습니다",
      },
    },
    explanation:
      "(B)는 현재 검토 중이라는 내용으로, 이미 승인한 사람이 누구인지를 묻는 질문에 맞지 않음. (C)는 보고서에 대한 의견일 뿐, 질문과 무관함.",
  },
  {
    questionNumber: "7",
    questionText: "Who is going to present the quarterly sales report?",
    choices: {
      A: "That's scheduled for next Monday",
      B: "Ms. Johnson will handle the presentation",
      C: "Sales have increased significantly",
    },
    incorrectAnswers: ["A", "C"],
    subCategory: "who",
    audioUrl: `${process.env.PUBLIC_URL}/audios/part2/who/us/who7.mp3`,
    translation: {
      question: "누가 분기별 매출 보고서를 발표할 예정입니까?",
      choices: {
        A: "다음 월요일로 예정되어 있습니다",
        B: "Johnson씨가 발표를 맡을 것입니다",
        C: "매출이 크게 증가했습니다",
      },
    },
    explanation:
      "(A)는 발표 일정만 말할 뿐, 발표자가 누구인지 말하지 않음. (C)는 매출 증가에 대한 정보만 제공함.",
  },
// ... existing code ...
{
  questionNumber: "8",
  questionText: "Who should I contact for IT support?",
  choices: {
    A: "The new software update was installed yesterday",
    B: "I had a similar issue last week",
    C: "You can submit a request through the company portal",
  },
  incorrectAnswers: ["A", "B"],
  subCategory: "who",
  audioUrl: `${process.env.PUBLIC_URL}/audios/part2/who/us/who8.mp3`,
  translation: {
    question: "IT 지원을 위해 누구에게 연락해야 합니까?",
    choices: {
      A: "새로운 소프트웨어 업데이트가 어제 설치되었습니다",
      B: "저도 지난주에 비슷한 문제가 있었습니다",
      C: "회사 포털을 통해 요청을 제출하실 수 있습니다",
    },
  },
  explanation:
    "(A)는 소프트웨어 업데이트에 대한 정보일 뿐, 지원 담당자에 대한 답이 아님. (B)는 개인의 경험을 말할 뿐, 누구에게 연락해야 하는지를 답하지 않음.",
},
// ... existing code ...
  // ... existing code ...
{
  questionNumber: "9",
  questionText: "Who can help me set up my new workstation?",
  choices: {
    A: "Your desk is in the corner by the window",
    B: "You should ask someone from the IT department",
    C: "I set up mine last week",
  },
  incorrectAnswers: ["A", "C"],
  subCategory: "who",
  audioUrl: `${process.env.PUBLIC_URL}/audios/part2/who/us/who9.mp3`,
  translation: {
    question: "누가 내 새 워크스테이션 설치를 도와줄 수 있습니까?",
    choices: {
      A: "당신의 책상은 창가 구석에 있습니다",
      B: "IT 부서에 문의해보세요",
      C: "저는 지난주에 제 것을 설치했습니다",
    },
  },
  explanation:
    "(A)는 책상 위치에 대한 정보일 뿐, 도움을 줄 수 있는 사람에 대한 답이 아님. (C)는 개인의 경험을 말할 뿐, 누가 도와줄 수 있는지를 답하지 않음.",
},
// ... existing code ...
  {
    questionNumber: "10",
    questionText: "Who approved the recent project proposal?",
    choices: {
      A: "The CEO signed it last week",
      B: "Yes, it was a great proposal",
      C: "The deadline is next Friday",
    },
    incorrectAnswers: ["B", "C"],
    subCategory: "who",
    audioUrl: `${process.env.PUBLIC_URL}/audios/part2/who/us/who10.mp3`,
    translation: {
      question: "누가 최근 프로젝트 제안서를 승인했습니까?",
      choices: {
        A: "CEO가 지난주에 서명했습니다",
        B: "네, 좋은 제안서였습니다",
        C: "마감일은 다음 금요일입니다",
      },
    },
    explanation:
      "(B)는 프로젝트에 대한 의견이지만, 승인한 사람이 누구인지를 답하지 않음. (C)는 마감일을 언급할 뿐, 질문과 맞지 않음.",
  },
  {
    questionNumber: "11",
    questionText: "Who is responsible for ordering office supplies?",
    choices: {
      A: "There are plenty of supplies in the storage room",
      B: "The admin team handles that",
      C: "I think we need more pens and notebooks",
    },
    incorrectAnswers: ["A", "C"],
    subCategory: "who",
    audioUrl: `${process.env.PUBLIC_URL}/audios/part2/who/us/who11.mp3`,
    translation: {
      question: "누가 사무용품 주문을 담당합니까?",
      choices: {
        A: "창고에 물품이 충분히 있습니다",
        B: "관리팀이 담당합니다",
        C: "펜과 노트가 더 필요할 것 같습니다",
      },
    },
    explanation:
      "(B)가 정답. (A)는 재고 여부를 언급할 뿐, 담당자 정보 없음. (C)는 필요한 물품을 말할 뿐, 누가 주문하는지를 답하지 않음.",
  },
  {
    questionNumber: "12",
    questionText: "Who is responsible for scheduling client meetings?",
    choices: {
      A: "The next meeting is on Wednesday",
      B: "You should ask the administrative assistant",
      C: "I attended a client meeting last week",
    },
    incorrectAnswers: ["A", "C"],
    subCategory: "who",
    audioUrl: `${process.env.PUBLIC_URL}/audios/part2/who/us/who12.mp3`,
    translation: {
      question: "누가 고객 미팅 일정을 담당합니까?",
      choices: {
        A: "다음 미팅은 수요일입니다",
        B: "행정 보조원에게 문의해보세요",
        C: "저는 지난주에 고객 미팅에 참석했습니다",
      },
    },
    explanation:
      "(A)는 미팅 일정에 대한 정보일 뿐, 일정 담당자에 대한 답이 아님. (C)는 개인의 미팅 참석 경험을 말할 뿐, 일정 담당자와 관련이 없음.",
  },
  {
    questionNumber: "13",
    questionText: "Who will be presenting at the conference?",
    choices: {
      A: "The agenda was sent out yesterday",
      B: "I registered for the event last week",
      C: "I heard it's going to be one of the senior executives",
    },
    incorrectAnswers: ["A", "B"],
    subCategory: "who",
    audioUrl: `${process.env.PUBLIC_URL}/audios/part2/who/us/who13.mp3`,
    translation: {
      question: "누가 컨퍼런스에서 발표할 예정입니까?",
      choices: {
        A: "일정표가 어제 발송되었습니다",
        B: "저는 지난주에 행사에 등록했습니다",
        C: "고위 임원 중 한 분이 하실 것이라고 들었습니다",
      },
    },
    explanation:
      "(A)는 일정표 발송에 대한 정보일 뿐, 발표자가 누구인지 말하지 않음. (B)는 개인의 등록 경험을 말할 뿐, 발표자와 관련이 없음.",
  },
  {
    questionNumber: "14",
    questionText: "Who is responsible for managing our company's social media?",
    choices: {
      A: "The marketing team handles that",
      B: "The IT department handles that",
      C: "I'll check if someone is available",
    },
    incorrectAnswers: ["A", "B"],
    subCategory: "who",
    audioUrl: `${process.env.PUBLIC_URL}/audios/part2/who/us/who14.mp3`,
    translation: {
      question: "누가 우리 회사의 소셜 미디어를 관리합니까?",
      choices: {
        A: "마케팅팀이 담당합니다",
        B: "IT 부서가 담당합니다",
        C: "누가 가능한지 확인해보겠습니다",
      },
    },
    explanation:
      "(A)가 정답. (B)는 IT 부서가 담당할 것으로 가정하는 것이므로 정답이 아님. (C)는 확인해보겠다는 말로, 구체적인 답을 주지 않음.",
  },

  {
    questionNumber: "15",
    questionText: "Who will be leading the customer support team next month?",
    choices: {
      A: "The team has been growing rapidly",
      B: "I applied for a position there last week",
      C: "I heard they're considering an internal promotion",
    },
    incorrectAnswers: ["A", "B"],
    subCategory: "who",
    audioUrl: `${process.env.PUBLIC_URL}/audios/part2/who/us/who15.mp3`,
    translation: {
      question: "다음 달에 누가 고객 지원팀을 이끌 예정입니까?",
      choices: {
        A: "팀이 빠르게 성장하고 있습니다",
        B: "저는 지난주에 그 팀에 지원했습니다",
        C: "내부 승진을 고려 중이라고 들었습니다",
      },
    },
    explanation:
      "(A)는 팀의 성장에 대한 정보일 뿐, 새로운 리더가 누구인지에 대한 답이 아님. (B)는 개인의 지원 경험을 말할 뿐, 팀 리더와 관련이 없음.",
  },
// ... existing code ...
{
  questionNumber: "16",
  questionText: "Who do I need approval from to take a day off?",
  choices: {
    A: "That depends on your department's policy",
    B: "You need to submit your request by Friday",
    C: "I took a day off last week",
  },
  incorrectAnswers: ["B", "C"],
  subCategory: "who",
  audioUrl: `${process.env.PUBLIC_URL}/audios/part2/who/us/who16.mp3`,
  translation: {
    question: "휴가를 내기 위해 누구의 승인이 필요합니까?",
    choices: {
      A: "부서 정책에 따라 다릅니다",
      B: "금요일까지 신청서를 제출해야 합니다",
      C: "저는 지난주에 휴가를 냈습니다",
    },
  },
  explanation:
    "(B)는 신청 마감일에 대한 정보일 뿐, 승인 담당자가 누구인지 말하지 않음. (C)는 개인의 휴가 경험을 말할 뿐, 승인 담당자와 관련이 없음.",
},
// ... existing code ...
  {
    questionNumber: "17",
    questionText: "Who sent out the email about the policy update?",
    choices: {
      A: "I don't think I received that email",
      B: "The update will take effect next month",
      C: "You should check your inbox",
    },
    incorrectAnswers: ["A", "B"],
    subCategory: "who",
    audioUrl: `${process.env.PUBLIC_URL}/audios/part2/who/us/who17.mp3`,
    translation: {
      question: "누가 정책 업데이트에 대한 이메일을 보냈습니까?",
      choices: {
        A: "그 이메일을 받지 못한 것 같습니다",
        B: "업데이트는 다음 달부터 적용됩니다",
        C: "받은 편지함을 확인해보세요",
      },
    },
    explanation:
      "(C)가 정답. 이메일을 보낸 사람이 누구인지 직접적으로 답하지 않지만, 이메일에 있으니 확인하라는 말이 정답이 될 수 있음. (A)는 이메일을 받았는지 여부만 언급하고 있어 정답이 될 수 없음. (B)는 시작 시기를 말하는 내용이므로 질문과 관련 없음.",
  },
  {
    questionNumber: "18",
    questionText: "Who will be attending the international conference?",
    choices: {
      A: "That information is in the event schedule",
      B: "It depends on the budget approval",
      C: "The conference will be held in Singapore",
    },
    incorrectAnswers: ["B", "C"],
    subCategory: "who",
    audioUrl: `${process.env.PUBLIC_URL}/audios/part2/who/us/who18.mp3`,
    translation: {
      question: "누가 국제 컨퍼런스에 참석할 예정입니까?",
      choices: {
        A: "그 정보는 행사 일정표에 있습니다",
        B: "예산 승인 여부에 따라 달라집니다",
        C: "컨퍼런스는 싱가포르에서 열립니다",
      },
    },
    explanation:
      "(A)가 정답. 참석자 정보를 직접 주지 않지만, 일정표에서 확인할 수 있다고 안내하는 것도 정답이 될 수 있음. (B)는 예산 승인에 따라 결정된다는 내용으로, 참석자가 누구인지 명확하게 알려주지 않음. (C)는 행사 장소에 대한 정보일 뿐, 질문에 대한 답이 아님.",
  },
// ... existing code ...
{
  questionNumber: "19",
  questionText: "Who will handle the client presentation tomorrow?",
  choices: {
    A: "The presentation slides have been finalized",
    B: "I believe Jason from sales is in charge of it",
    C: "I attended a similar presentation last month",
  },
  incorrectAnswers: ["A", "C"],
  subCategory: "who",
  audioUrl: `${process.env.PUBLIC_URL}/audios/part2/who/us/who19.mp3`,
  translation: {
    question: "내일 고객 프레젠테이션을 누가 진행할 예정입니까?",
    choices: {
      A: "프레젠테이션 자료가 완성되었습니다",
      B: "영업부의 Jason이 담당할 것 같습니다",
      C: "저는 지난달에 비슷한 프레젠테이션에 참석했습니다",
    },
  },
  explanation:
    "(A)는 발표 자료 준비 상태에 대한 정보일 뿐, 발표자가 누구인지에 대한 답이 아님. (C)는 개인의 과거 참석 경험을 말할 뿐, 이번 발표자와 관련이 없음.",
},
// ... existing code ...
  {
    questionNumber: "20",
    questionText: "Who is in charge of approving the expense reports?",
    choices: {
      A: "It's due by Friday",
      B: "You should check the company policy document",
      C: "Yes, I submitted my report yesterday",
    },
    incorrectAnswers: ["A", "C"],
    subCategory: "who",
    audioUrl: `${process.env.PUBLIC_URL}/audios/part2/who/us/who20.mp3`,
    translation: {
      question: "누가 경비 보고서 승인을 담당합니까?",
      choices: {
        A: "금요일까지가 마감입니다",
        B: "회사 정책 문서를 확인해보세요",
        C: "네, 어제 제 보고서를 제출했습니다",
      },
    },
    explanation:
      "(B)가 정답. 승인 담당자를 직접 말하지 않지만, 문서에서 찾을 수 있다는 정보가 주어짐. (A)는 마감일에 대한 정보로, 질문과 관련 없음. (C)는 본인이 보고서를 제출했는지 여부만 말하고 있어 정답이 될 수 없음.",
  },
 
];
